/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "Wordleish.GameId",
                name: "gameId",
                type: "uint256",
            },
        ],
        name: "GameSolved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "Wordleish.GameId",
                name: "gameId",
                type: "uint256",
            },
        ],
        name: "GameStarted",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "Wordleish.GameId",
                name: "_gameId",
                type: "uint256",
            },
            {
                internalType: "Wordleish.Word",
                name: "_guess",
                type: "uint256",
            },
        ],
        name: "guess",
        outputs: [
            {
                internalType: "Wordleish.LetterMask",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "nextGameId",
        outputs: [
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "Wordleish.GameId",
                name: "",
                type: "uint256",
            },
        ],
        name: "solvers",
        outputs: [
            {
                internalType: "address",
                name: "firstSolver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "numSolves",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "Wordleish.Word",
                name: "_word",
                type: "uint256",
            },
        ],
        name: "startGame",
        outputs: [
            {
                internalType: "Wordleish.GameId",
                name: "gameId",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class Wordleish__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
Wordleish__factory.bytecode = _bytecode;
Wordleish__factory.abi = _abi;
//# sourceMappingURL=Wordleish__factory.js.map